import { TCommonData, TWidgetProps } from '@libs/types';
import { CoreLayoutView, TCoreLayoutStyleProps, TCoreLayoutViewProps } from '@core/widgets';
import React from 'react';
import { TVerticalLayoutOption } from '../../types/options';
import styles from './css/verticalLayout.module.css';

const toLine = (value?: string): TCoreLayoutStyleProps['lineY'] => (value ? (value.replace(/-/g, '_') as TCoreLayoutStyleProps['lineY']) : undefined);

export const VerticalLayoutWide: React.FC<TWidgetProps<TCommonData, TVerticalLayoutOption>> = ({ widget, children }) => {
    const alignment = widget.options?.alignment;
    const arrangement = widget.options?.arrangement;

    const styleProps: TCoreLayoutStyleProps = {
        lineY: toLine(arrangement),
        lineX: alignment === 'center' ? 'center' : alignment === 'bottom' ? 'bottom' : 'stretch',
    };

    return (
        <div data-test={widget.uid} className={styles.verticalLayoutWide}>
            <CoreLayoutView
                uid={'verticalLayoutWideInner_' + widget.uid}
                widget={widget as TCoreLayoutViewProps['widget']}
                styleProps={styleProps}
                isHide={widget.options?.isHide}
            >
                {children}
            </CoreLayoutView>
        </div>
    );
};
